import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAttributeSettingStore } from "csi/middleware/AttributeSettingStore";
import { ComponentFilterItem } from "csi/middleware/common";
import FilterDropdownList from "csi/middleware/filter/FilterDropdownList";
import { useStore } from "csi/state/hooks";
import { FlexColumn, Tab, TabPanel, Tabs } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useState } from "react";

const PREFIX = "PPAttributeSetting";

const classes = {
	popup: `${PREFIX}popup`,
};

const StyledFlexColumn = styled(FlexColumn)((
	{
		theme,
	},
) => ({
	[`& .${classes.popup}`]: {
		maxHeight: 454,
		minHeight: 454,
		maxWidth: 199,
		minWidth: 199,
	},
}));

export const PPAttributeSetting: FunctionComponent = observer((props) => {
	const {
		types,
		secondarySortedItems,
		primarySortedItems,
		preSelectIds,
		primaryType,
		secondaryType,
		postCheckPrimaryItems,
		postCheckSecondaryItems,
	} = useAttributeSettingStore() || {};

	const { localStore } = useStore();
	const { productPresentation } = localStore;
	const { adHocIdsList } = productPresentation;


	const adHocIdsListForPrimaryType = adHocIdsList.get(primaryType);
	const adHocIdsListForSecondaryType = adHocIdsList.get(secondaryType);

	const defaultTabIndex = 0;
	const [selectedIndex, setSelectedIndex] = useState(defaultTabIndex);

	/** handle the logic when switch tabs */
	const handleChange = (event: any, newValue: number) => {
		setSelectedIndex(newValue);
	};
	const { popup } = classes;

	return (
		<StyledFlexColumn pt={2}>
			<Tabs
				onChange={handleChange}
				value={selectedIndex}
				variant="fullWidth"
			>
				{types?.map((type, index) => <Tab key={`${type}${index}`} label={type} />)}
			</Tabs>
			{types?.map((type, index) => (
				<TabPanel
					index={index}
					key={`Tab${type}${index}`}
					selectedTabIndex={selectedIndex}
				>
					<Box p={2}>
						<FilterDropdownList<ComponentFilterItem>
							adHocIds={index === 0 ? adHocIdsListForPrimaryType : adHocIdsListForSecondaryType}
							className={popup}
							fixedIds={preSelectIds}
							items={index === 0 ? primarySortedItems : (secondarySortedItems || [])}
							postCheckItems={index === 0 ? postCheckPrimaryItems : postCheckSecondaryItems}
							scroll
						/>
					</Box>
				</TabPanel>
			),
			)}
		</StyledFlexColumn>
	);
});

export default PPAttributeSetting;